export default __webpack_public_path__ + "7df8b38bec9a86673825df3c88a5d2b9.png";